import { HttpErrorResponse } from '@angular/common/http';

import { createAction } from '@ngrx/store';

import { AbtestingProfile } from '../../models/abtesting-profile.dto';

const GET_TESTS = '[ABTests] Get tests';
const GET_TESTS_SUCCESS = '[ABTests] Get tests success';
const GET_TESTS_FAIL = '[ABTests] Get tests fail';

export const GetTests = createAction(GET_TESTS);
export const GetTestsSuccess = createAction(
  GET_TESTS_SUCCESS,
  (response: AbtestingProfile) => ({ response }),
);
export const GetTestsFail = createAction(
  GET_TESTS_FAIL,
  (err: HttpErrorResponse) => ({ err }),
);
